export default __webpack_public_path__ + "static/media/nestjs.e0a8a56c.svg";